import { FC, useState } from 'react';
import Modal from '../../components/shared/Modal/Modal';
import Field from '../../components/shared/Field/Field';
import InfoBox from '../../components/shared/InfoBox/InfoBox';
import { ServiceSupplier } from '../../services/service-supplier';
import { NotificationManager } from 'react-notifications';
import { useTranslation } from 'react-i18next';

type Props = {
  show: boolean;
  setShow: (value: boolean) => void;
  supplierIds: string[];
  onSave: () => void;
  mode: 'block' | 'unblock';
};

const BulkBlockSuppliersModal: FC<Props> = ({ show, setShow, supplierIds, onSave, mode }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: `bulkActions.${mode}` });
  const [reason, setReason] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!reason.trim()) return;
    setIsSaving(true);
    try {
      const serviceCall = mode === 'block' ? ServiceSupplier.bulkBlock : ServiceSupplier.bulkUnblock;
      const result = await serviceCall(supplierIds, reason);
      NotificationManager.success(
        t('notification.success', '{{count}} leverantörer uppdaterade', { count: result.updated }),
        t('notification.title', 'Sparat')
      );
      setReason('');
      setShow(false);
      onSave();
    } catch (e) {
      const errorMsg = (e as any)?.response?.data?.error ?? t('notification.error', 'Fel');
      NotificationManager.error(errorMsg, t('notification.error', 'Fel'));
    }
    setIsSaving(false);
  };

  return (
    <Modal
      show={show}
      setShow={(v) => { setReason(''); setShow(v); }}
      title={mode === 'block'
        ? t('title', 'Spärra {{count}} leverantörer', { count: supplierIds.length })
        : t('title', 'Ta bort spärr för {{count}} leverantörer', { count: supplierIds.length })}
      buttonInfo={{
        label: mode === 'block' ? t('button', 'Spärra') : t('button', 'Ta bort spärr'),
        action: handleSave,
        loaderShow: isSaving,
        disabled: !reason.trim(),
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '14px' }}>
        {supplierIds.length > 100 && (
          <InfoBox description={t('slowWarning', 'Du har valt {{count}} leverantörer – åtgärden kan ta ett tag.', { count: supplierIds.length })} />
        )}
        <p style={{ color: 'var(--gray-700)' }}>
          {mode === 'block'
            ? t('description', 'Hindra de valda leverantörerna från att väljas i projekt.')
            : t('description', 'Tillåt de valda leverantörerna att väljas i projekt igen.')}
        </p>
        <Field label={t('reasonLabel', 'Skriv anledning')} value={reason} onChange={setReason} />
      </div>
    </Modal>
  );
};

export default BulkBlockSuppliersModal;
